import { render, staticRenderFns } from "./BaseReviewMemberPopup.vue?vue&type=template&id=15f2f090&scoped=true&"
import script from "./BaseReviewMemberPopup.vue?vue&type=script&lang=js&"
export * from "./BaseReviewMemberPopup.vue?vue&type=script&lang=js&"
import style0 from "./BaseReviewMemberPopup.vue?vue&type=style&index=0&id=15f2f090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f2f090",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDivider,VIcon})
